/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SpecialitySaveModel } from '../../models/speciality-save-model';

export interface AdminLinkUnlinkHealthcareServicesToSpecialityPost$Params {
      body?: Array<SpecialitySaveModel>
}

export function adminLinkUnlinkHealthcareServicesToSpecialityPost(http: HttpClient, rootUrl: string, params?: AdminLinkUnlinkHealthcareServicesToSpecialityPost$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, adminLinkUnlinkHealthcareServicesToSpecialityPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as OrganizationStrictHttpResponse<void>;
    })
  );
}

adminLinkUnlinkHealthcareServicesToSpecialityPost.PATH = '/Admin/LinkUnlinkHealthcareServicesToSpeciality';
